import { Component, Input } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { TimeOffTransaction } from '@app/models/time-off-v3/time-off-transaction.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { getTime, setTime } from '@time-off-v3/functions/time-unit-converter';
import { TimeOffDateFormatDashes } from '@time-off-v3/meta/time-off-meta';
import cloneDeep from 'lodash-es/cloneDeep';
import moment from 'moment';
import { AttachEmployee } from '../../interfaces/time-off-assign.interface';
import { TimeOffBalance } from '../../interfaces/time-off-balance.interface';
import { TimeOffService } from '../../services';

interface EmployeeWithBalance {
    employee: Employee;
    timeOffBalance: TimeOffBalance;
}

type AccrualStartDate = 'Date Hired' | 'Select a date';

@Component({
    selector: 'app-employee-addition-form',
    templateUrl: './employee-addition.form.html',
    styleUrls: ['./employee-addition.form.scss'],
})
export class EmployeeAdditionForm extends BaseForm {
    @Input() additions: Employee[] = [];
    @Input() timeOffPolicy: TimeOffPolicy = new TimeOffPolicy();

    policyAttach: AttachEmployee[] = [];
    employeesWithBalance: EmployeeWithBalance[] = [];
    employeesWithBalanceCache: EmployeeWithBalance[] = [];
    timeOffBalanceTransactions: TimeOffTransaction[] = [];
    userSelectedDate: Date = new Date();
    accrualStartDate: AccrualStartDate = 'Date Hired';

    constructor(private timeOffService: TimeOffService) {
        super();
    }

    async getBalances(): Promise<void> {
        this.employeesWithBalance = await Promise.all(
            this.additions.map(async (employee: Employee) => {
                const processedAt =
                    this.accrualStartDate === 'Date Hired'
                        ? employee.hiredAt
                        : moment(this.userSelectedDate).format(TimeOffDateFormatDashes);

                const timeOffBalance = await this.timeOffService.getBalance(employee.id, {
                    'filters[timeOffTypeId]': this.timeOffPolicy.timeOffTypeId,
                    'filters[processedAt][to]': processedAt,
                });

                return { employee, timeOffBalance };
            })
        );

        // Cache the calculated result to do check later if we need to create adjustment records
        this.employeesWithBalanceCache = cloneDeep(this.employeesWithBalance);
    }

    getBalance(balance: number): number {
        return getTime(balance, this.timeOffPolicy.timeOffType);
    }

    setBalance(balance: number, employeeWithBalance: EmployeeWithBalance): void {
        employeeWithBalance.timeOffBalance.balance = setTime(balance, this.timeOffPolicy.timeOffType);
    }

    setEffectiveAtDate(): void {
        this.policyAttach = this.additions.map((employee) => {
            return {
                id: employee.id,
                effectiveAt: this.accrualStartDate === 'Date Hired' ? employee.hiredAt : this.userSelectedDate,
            };
        });
    }
}
